export const API_URL = process.env.REACT_APP_API_URL || "";
export const API_KEY = process.env.REACT_APP_API_KEY || "";
export const PROFILE_URL = process.env.REACT_APP_PROFILE_URL || "";
export const APP_DOMAIN = process.env.REACT_APP_APP_DOMAIN || "";
export const PLATFORM_PUBLIC_URL = process.env.REACT_APP_PLATFORM_PUBLIC_URL || "";
